// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bordered-icon[data-v-2cbf49dc]{border:1px solid;line-height:0}.leading-tight[data-v-2cbf49dc]{line-height:1!important}.currency-symbol[data-v-2cbf49dc]{font-size:12px;height:1em;width:1em}.striked[data-v-2cbf49dc]{-webkit-text-decoration:line-through;text-decoration:line-through}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
